import axios from "axios";
import { TOKEN_KEY } from "./mw";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

let pending = 0;
function emit() {
  window.dispatchEvent(new CustomEvent("mw-loading", { detail: { pending } }));
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const tid = localStorage.getItem("mwcrm_tenant");
  if (tid) config.headers["X-Tenant-Id"] = tid;
  const yr = localStorage.getItem("mwcrm_year");
  if (yr) config.headers["X-Year"] = yr;
  if (!config.silent) {
    pending += 1;
    emit();
  }
  return config;
});

api.interceptors.response.use(
  (res) => {
    if (!res.config.silent) {
      pending = Math.max(0, pending - 1);
      emit();
    }
    return res;
  },
  (err) => {
    if (!err.config?.silent) {
      pending = Math.max(0, pending - 1);
      emit();
    }
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
